module.exports = __webpack_public_path__ + "img/wuliuyunshu.d6e2e240.png";